import React, { useMemo, useState } from "react";
import { Typography, CircularProgress, Box } from "@mui/material";
import PageLayout from "../components/PageLayout";
import CategoryFilter from "../components/CategoryFilter";
import ProjectGrid from "../components/ProjectGrid";
import { useProjects, ALL_CATEGORY } from "../data/projects";

const Projects: React.FC = () => {
    const { data, error, loading } = useProjects();
    const [selected, setSelected] = useState<string>(ALL_CATEGORY);

    const visibleProjects = useMemo(() => {
        if (!data) return [];
        return selected === ALL_CATEGORY
            ? data.projects
            : data.projects.filter((project) => project.category === selected);
    }, [data, selected]);

    return (
        <PageLayout title="Projekte">
            <Typography variant="body1" color="inherit" sx={{ textAlign: "justify", mb: 4 }}>
                In unserer Werkstatt produzieren wir vielerlei Dinge. Über Weihnachten Weihnachtsdeko und Geschenke,
                unter dem Jahr Möbel und Schneidbretter. Mit viel Freude an der Arbeit konnten wir schon einige
                Projekte abschliessen.
            </Typography>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
                    <CircularProgress color="primary" />
                </Box>
            )}

            {error && (
                <Typography align="center" sx={{ color: "common.white" }}>
                    Projekte konnten nicht geladen werden.
                </Typography>
            )}

            {data && (
                <>
                    <CategoryFilter categories={data.categories} selected={selected} onSelect={setSelected} />
                    <ProjectGrid projects={visibleProjects} categories={data.categories} />
                </>
            )}
        </PageLayout>
    );
};

export default Projects;
